export default __webpack_public_path__ + "static/media/flag-th.ecb17cda.svg";